import React, {useEffect, useState} from 'react';
import InputGroup from 'deprecated-shared-ui/templates/input/Group.jsx';
import Select from 'deprecated-shared-ui/templates/input/Select.jsx';
import Label from 'deprecated-shared-ui/templates/input/Label.jsx';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from '../messages';
import ChangeItemLandmarks from './changeItemLandmarks.js';
import findCorrectDigistyleId from '../../helper/find-digistyle-helper.js';

export default function ItemSelection({
                                          items,
                                          product,
                                          selectedItem,
                                          headline,
                                          layerOrigin,
                                          channelId,
                                          isSingleColor,
                                          setSelectedItem,
                                          selectedItemOption,
                                          setSelectedItemOption,
                                          setIsItemOptionError
                                      }) {
    const [currentItems, setCurrentItems] = useState(items);
    const [currentSelectedItem, setCurrentSelectedItem] = useState(selectedItem);
    const [isCurrentSingleColor, setIsCurrentSingleColor] = useState(isSingleColor);

    useEffect(() => {
        MessageBroker.subscribe(Messages.LAYER.CHANGE_ITEM_CHANGE_STYLE, ({items, selectedItem, isSingleColor}) => {
            setCurrentItems(items);
            setCurrentSelectedItem(selectedItem);
            setIsCurrentSingleColor(isSingleColor);
        });
    });

    const findEquivalentItemOption = (item, otherItemOption) => {
        if (product.coliItemsCount || item.itemOptions.length === 1) {
            return item.itemOptions[0];
        } else if (otherItemOption) {
            return item.itemOptions.find((option) => option.name === otherItemOption.name);
        } else {
            return null;
        }
    };

    const changeItem = (e) => {
        const itemId = parseInt(e.target.value);
        const newItem = currentItems.find((item) => item.id === itemId);

        setCurrentSelectedItem(newItem);

        const currentSelectedItemOption = findEquivalentItemOption(newItem, selectedItemOption);

        setSelectedItem(newItem);
        setSelectedItemOption(currentSelectedItemOption);
        setIsItemOptionError(false);

        ChangeItemLandmarks.sendOnChangeItemClickLandmark(layerOrigin, newItem, channelId, findCorrectDigistyleId(newItem), product.id);

    };

    if (!currentItems) {
        return null;
    }

    if (isCurrentSingleColor) {
        return (
            <div className="change-item__selection">
                <div className="change-item__selection-label">{headline}</div>
                {currentSelectedItem.name}
                <input type="hidden" name="color" value={currentSelectedItem.name} />
            </div>
        );
    }
    const itemNodes = [];
    currentItems.forEach((item, index) => {
        itemNodes.push(<option key={index} value={item.id}>{item.name}</option>);
    });

    return (
        <div className="change-item__selection">
            <InputGroup className="change-item__selection-input-group">
                <Label className="input-group__label">{headline}</Label>
                <Select name="color" value={currentSelectedItem.id} onChange={changeItem}>
                    {itemNodes}
                </Select>
            </InputGroup>
        </div>
    );
}
